var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partner-search-bar"},[_c('FormulateInput',{attrs:{"type":"search","name":"sample","label":"Search by Driver ID Or Mobile Number"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }